<template>
  <v-app
    id="inspire"
    v-if="$route.name != 'Login' && this.$route.name != 'Root'"
  >
    <side-bar-navigation />
    <!-- Content -->
    <v-main style="padding-top: 0 !important;">
    <top-toolbar />
      <v-container container--fluid fill-height>
        <v-layout>
          <v-fade-transition mode="out-in">
            <router-view />
          </v-fade-transition>
        </v-layout>
      </v-container>
    </v-main>

    <!-- Footer -->
    <bottom-footer />
  </v-app>
</template>

<script>
import SideBarNavigation from "./components/TheNavigationDrawer";
import TopToolbar from "./components/TheToolbar";
import BottomFooter from "./components/ThePageFooter";
export default {
  components: {
    SideBarNavigation,
    TopToolbar,
    BottomFooter,
  },
};
</script>

<style>
.fullwidth {
  max-width: 100%;
}
</style>